export default __webpack_public_path__ + "static/media/aha-mainnav-footer-icon-withtext.92a6bbf8.svg";